import { useState } from "react";
import VideoIcon from "../../media/videoIcon.svg";
import HeartImage from "../../media/heartImage.svg";
import ArrowImage from "../../media/arrowImage.svg";
import AssetIcon from "../../media/assetIcon.svg";
// import "./ImageGallery.css";

export default function ImageGallery({ items = [] }) {
    const [active, setActive] = useState(items[0]);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;

        if (distance > 50) {
            // swipe left
            const next = (items.indexOf(active) + 1) % items.length;
            setActive(items[next]);
        }

        if (distance < -50) {
            // swipe right
            const prev =
            (items.indexOf(active) - 1 + items.length) % items.length;
            setActive(items[prev]);
        }
    };

    const noImage =
        "https://assets.diamondsoncall.com/assets/shapes/sample/noimage.jpg";

    const handleError = (e) => {
        const img = e.target;

        // prevent infinite loop
        if (!img.dataset.fallback) {
            img.dataset.fallback = true;

            // if shape fallback failed → noimage
            if (img.src.includes("-no.png")) {
                img.src = noImage;
            } else {
                img.src = items[0]?.src || noImage;
            }
        }
    };

    return (
        <div className="gallery">
            {/* THUMBS */}
            <div className="thumbs">
                {items.map((item, i) => (
                    <div
                        key={i}
                        className={`thumb ${active === item ? "active" : ""}`}
                        onClick={() => setActive(item)}
                    >
                        {item.name === "video" ? (
                            <img src={VideoIcon} alt="" style={{padding:8}} loading="lazy"/>
                        ) : item.name === "heart" ? (
                            <img src={HeartImage} alt="" style={{padding:8}} loading="lazy" />
                        ) : item.name === "arrow" ? (
                            <img src={ArrowImage} alt="" style={{padding:8}} loading="lazy" />
                        ) : item.name === "asset" ? (
                            <img src={AssetIcon} alt=""  style={{padding:8}} loading="lazy" />
                        ) : (
                            <img src={item.src} alt="" onError={handleError} loading="lazy" />
                        )}
                    </div>
                ))}
            </div>

            {/* MAIN */}
            <div 
                className="main"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {active?.type === "video" ? (
                    <div className="iframe-wrapper">
                        <iframe
                            src={active.src}
                            allowFullScreen
                            title="diamond-video"
                            frameBorder={"0"}
                        />
                    </div>
                ) : (
                    <img src={active?.src} alt="" onError={handleError} loading="lazy" />
                )}
            </div>
        </div>
    );
}
